<template>
  <div>
    <entry-history-dialog ref="entryHistoryDialog"></entry-history-dialog>
    <div class="message_history_table">
      <el-table class="mb-x2" :data="data" stripe @header-click="headerClick">
        <el-table-column label="応募日時" sort-by="-entryDatetime" :render-header="renderHeader" min-width="14%">
          <template slot-scope="scope"
            >{{ formatDate(scope.row.entryDatetime) }}<br />{{ formatTime(scope.row.entryDatetime) }}</template
          >
        </el-table-column>
        <el-table-column label="種別" sort-by="-messageType" :render-header="renderHeader" min-width="8%">
          <template slot-scope="scope">
            <div class="label label-primary" type="primary" v-if="scope.row.messageType === 'win'">当選</div>
            <el-tooltip
              placement="top"
              :content="loseReasonTooltip(scope.row.loseReason)"
              v-if="scope.row.messageType === 'lose'"
            >
              <div class="label label-default">落選</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="メッセージ名" sort-by="name" :render-header="renderHeader" min-width="14%">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column label="アカウント情報" sort-by="applicant" :render-header="renderHeader" min-width="16%">
          <template slot-scope="scope">
            <applicant-name :applicant="scope.row.applicant"></applicant-name>
          </template>
        </el-table-column>
        <el-table-column label="フォロワー" sort-by="-followersCount" :render-header="renderHeader" min-width="11%">
          <template slot-scope="scope">{{ formatNumber(scope.row.applicant.followersCount) }}</template>
        </el-table-column>
        <el-table-column label="ポスト" sort-by="-tweetsCount" :render-header="renderHeader" min-width="11%">
          <template slot-scope="scope">{{ formatNumber(scope.row.applicant.tweetsCount) }}</template>
        </el-table-column>
        <el-table-column label="応募回数" :render-header="renderHeader" min-width="10%">
          <template slot-scope="scope">
            <div>{{ formatNumber(scope.row.currentEntryCount) }}</div>
            <div
              class="sub-value"
              @click="$refs.entryHistoryDialog.open(scope.row.applicant.name, scope.row.applicant.accountId, 0)"
            >
              累計:&nbsp;{{ formatNumber(scope.row.totalEntryCount) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="当選回数" :render-header="renderHeader" min-width="10%">
          <template slot-scope="scope">
            <div>{{ formatNumber(scope.row.currentWinnerCount) }}</div>
            <div
              class="sub-value"
              @click="$refs.entryHistoryDialog.open(scope.row.applicant.name, scope.row.applicant.accountId, 1)"
            >
              累計:&nbsp;{{ formatNumber(scope.row.totalWinnerCount) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="16%">
          <template slot-scope="scope">
            <div layout layout-align="end">
              <!-- 回答者フラグ-->
              <el-tooltip
                :enterable="false"
                v-if="scope.row.applicant.isResponder === 1 && scope.row.messageType === 'win'"
                placement="top"
                content="回答者を解除"
              >
                <div class="mr-button">
                  <el-button
                    class="is-responder-button el-button--icon"
                    type="primary"
                    @click="updateFlag(scope.row.applicant.id, scope.row.applicant.isResponder, 'responder')"
                    ><i class="mdi mdi-clipboard-check"></i
                  ></el-button>
                </div>
              </el-tooltip>
              <el-tooltip
                :enterable="false"
                v-if="scope.row.applicant.isResponder === 0 && scope.row.messageType === 'win'"
                placement="top"
                content="回答者に追加"
              >
                <div class="mr-button">
                  <el-button
                    class="is-responder-button el-button--icon"
                    type="default"
                    @click="updateFlag(scope.row.applicant.id, scope.row.applicant.isResponder, 'responder')"
                    ><i class="mdi mdi-clipboard-check"></i
                  ></el-button>
                </div>
              </el-tooltip>
              <!-- メッセージ履歴-->
              <el-tooltip
                :enterable="false"
                v-if="scope.row.messageType === 'win'"
                placement="top"
                content="当選メッセージ配信履歴"
              >
                <div class="mr-button">
                  <el-button
                    class="message-button el-button--icon"
                    type="default"
                    :disabled="scope.row.messagesCount <= 0"
                    @click="openMessageHistory(scope.row.applicant.id)"
                    ><i class="mdi mdi-message-text"></i>
                    <div class="badge badge-active" v-if="scope.row.messagesCount > 0">
                      {{ formatNumber(scope.row.messagesCount) }}
                    </div>
                  </el-button>
                </div> </el-tooltip
              ><a
                :href="'https://x.com/' + scope.row.applicant.accountId + '/status/' + scope.row.entryTweetId"
                target="_blank"
              >
                <el-tooltip :enterable="false" placement="top" :content="'Xで応募ポストを確認'">
                  <el-button class="el-button--icon" type="default"
                    ><i class="mdi mdi-open-in-new"></i
                  ></el-button> </el-tooltip
              ></a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="paginations.total"
        :pagingNo="paginations.pagingNo"
        :limitCount="paginations.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.label {
  display: inline-block;
  padding: 0 $spacing-unit;
  color: $text-color-white;
  border-radius: 5px;

  &.label-primary {
    background-color: $primary-color;
  }

  &.label-default {
    background-color: $disabled-color;
  }
}

.sub-value {
  font-size: $font-small-size;
  color: $sub-text-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.mr-button {
  margin-right: $spacing-unit + 2;
}

.message-button {
  position: relative;
}

.badge {
  right: -4px;
  bottom: 0;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import Pagination from '@/client/components/_atoms/pagination'
import { INSTANTWIN_LOSE_REASON } from '@/client/constant'
import Util from '@/client/core/util'
import EntryHistoryDialog from '@/client/features/twitter_instantwin_message_history/entry_history_dialog'
import { formatDate, formatNumber, formatTime } from '@/client/filters/filters'

export default defineComponent({
  props: {
    data: Array,
    options: Object,
    paginations: Object,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    onChangeSortBy: Function
  },
  components: {
    ApplicantName,
    Pagination,
    EntryHistoryDialog
  },
  methods: {
    formatDate,
    formatNumber,
    formatTime,

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.options.sortBy, column.sortBy),
        !!column.sortBy
      )
    },

    /**
     * 落選となった理由をツールチップで表示
     * @param {string | null} value 値
     */
    loseReasonTooltip(value: string | null) {
      const key = value === null ? 'other' : value
      return INSTANTWIN_LOSE_REASON[key]
    },

    /**
     * フラグ変更処理
     * @param {number} applicantId
     * @param {number} value
     * @param {string} type
     */
    updateFlag(applicantId: number, value: number, type: string) {
      const payload = {
        type,
        value: {}
      }

      switch (type) {
        case 'responder':
          payload.value = {
            applicantId,
            isResponder: value === 0 ? 1 : 0
          }
          break
      }
      this.$emit('change_flag', payload)
    },

    /**
     * メッセージ配信履歴を開く
     * @param {number} applicantId
     */
    openMessageHistory(applicantId: number) {
      this.$emit('open_message_history', {
        applicantId
      })
    }
  }
})
</script>
